/**
 * Import Dependency
 */
import { handleActions } from 'redux-actions'
// import update from 'immutability-helper'

/**
 * Declare Variable
 */

/**
 * Export
 */
export const locale = handleActions({
  SWITCH_LOCALE: (state, action) => {
    return action.payload
  },
}, null)

export const userLocale = handleActions({
  SET_USER_LOCALE: (state, action) => {
    return action.payload
  },
}, null)

export default {
  locale,
  userLocale,
}



// WEBPACK FOOTER //
// ./src/reducers/intl/index.js